export default __webpack_public_path__ + "static/firelighter-2455ec6e19a43abc392d1b4266e035f7.jpg";